import { faCopy } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//COMPONENTS
import Label from "../../../../../../../Components/Label";
import ButtonCustom from "../../../../../../../Components/ButtonCustom";
import { Box } from "../../../../../../../Components/CustomUi/box";
import { CopiableRow } from "../../../../../../../Components/CustomUi/copiableRow";
import { ItemRequest } from "../../../../../../../services/logs";
import { Render } from "../../../../../../../Components/CustomUi/render";
import { Empty } from "antd";
import { copyJson } from "./meta";

//PROPS
interface Props {
    request_selected: ItemRequest;
}

export const ParamsRequest: React.FC<Props> = ({ request_selected }) => {

    const { queryParams } = request_selected?.descricao ?? {};
    const params = Object.entries(queryParams).map(([chave, valor], index) => { return { descr: chave, value: valor, key: index }; });

    return (
        <Box padding={15}>

            <Render condition={params.length > 0}>
                <Label style={{fontWeight: 700, color: 'var(--text-color-light)', fontSize:13}} >Parametros da requisição</Label>

                <div style={{display:'flex', flexDirection:'column'}}>
                    {(params ?? []).map(({ descr, value, key })=> {
                        return (
                            <CopiableRow 
                                key={key}
                                atribute={descr}
                                value={value}
                                isLast={params.length === (key + 1)}
                            />
                        )
                    })}
                </div>

                <ButtonCustom 
                    onClick={()=>{copyJson(request_selected)}}
                    type='secondary'
                    style={{alignSelf:'flex-start'}}
                    icon={<FontAwesomeIcon icon={faCopy} />}
                >
                    Copiar JSON
                </ButtonCustom>
            </Render>
            
            <Render condition={params.length === 0}>
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>Requisição não possui parametros</>} />
            </Render>
            
        </Box>
    )
}